module.exports = __webpack_public_path__ + "static/media/triangle.3daf4b64.svg";